export default "__VITE_ASSET__BDiUS6AP__"